import API from 'services/api';

export const getReservationTypeOfService = (
  serviceType?: string | null | undefined,
): Promise<any> => {
  if (!serviceType) {
    return API.get(`/api/root/services/accommodation`).then(response => response?.data);
  } else {
    return API.get('/api/root/services/accommodation', {
      params: { 'EqualsTo[TipUsluge]': serviceType },
    }).then(response => response?.data);
  }
};
